import React, {useEffect, useState} from 'react';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core';
import { Card, CardContent, Grid, TextField, Tooltip, IconButton } from '@material-ui/core';
import { Refresh } from '@material-ui/icons';
import { hasPermission } from '../../../sc-utilities';

import DataRange from './DataRangeForm'
import * as Yup from "yup";
import moment from 'moment'
import momentTimezone from 'moment-timezone';

const styles = theme => ({
    refresh: {
        display: 'inline-block',
        marginTop: '20px',
    },
    content: {
        pendingBottom: '0px',
        display: 'flex',
    },
    root: {
        pendingBottom: '0px'

    },
    root2: {
        display: 'inline-flex',
    },
    root3: {
        marginTop: '37px',
    },

});

let columnSearchTimeout = null;

const HeaderCard = props => {
    const { className, classes, setLoading, setOverview, numberOfStorages, fetchStatistic, activeCustomer, permissions, translations, loading, hideOptions, fromKPI, refetchTab, setRefetchTab, ...rest } = props;
    const [name, setName] = useState();
    const [dateRangeValue, setDateRangeValue] = useState(null);

    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            Key: Yup.string().required("Required"),
        }
    };

    useEffect(() => {
        const customerTimezone = window.localStorage.getItem("CustomerTimezone") ?? 'UTC';

        const from = momentTimezone.tz(moment().subtract(7, 'days').set({
            hours: 0,
            minutes: 0,
            seconds: 0
        }), customerTimezone);

        const to = momentTimezone.tz(moment(), customerTimezone);
        
        setDateRangeValue({
            From: from,
            To: to,
            ShowOnlyMyErasures: false,
            maxDate: to.set({
                hours: 23,
                minutes: 59,
                seconds: 59,
            })
        });
        // eslint-disable-next-line
    }, [ activeCustomer ]);

    const handleChange = async event => {
        setName(event.target.value);
        const customerName = event.target.value;
        if (columnSearchTimeout) {
            clearTimeout(columnSearchTimeout);
        }
        columnSearchTimeout = setTimeout(async () => {

            setLoading(true);
            let data = await fetchStatistic({ ActiveCustomerID: activeCustomer, CustomerName: customerName, From: dateRangeValue?.From.format('YYYY-MM-DD'), To: dateRangeValue?.To.format('YYYY-MM-DD'), ShowOnlyMyErasures: dateRangeValue?.ShowOnlyMyErasures });
            setLoading(false);
            setOverview(data);
        }, 600);
    };

    const filterCustomer = async (name) => {
        setLoading(true);
        let data = await fetchStatistic({ ActiveCustomerID: activeCustomer, CustomerName: name, From: dateRangeValue?.From.format('YYYY-MM-DD'), To: dateRangeValue?.To.format('YYYY-MM-DD'), ShowOnlyMyErasures: dateRangeValue?.ShowOnlyMyErasures });
        setLoading(false);
        setOverview(data);
    };

    const filterDataRange = async (range) => {
        if (fromKPI) {
            return;
        }
        setLoading(true);
        let data = await fetchStatistic({ ActiveCustomerID: activeCustomer, CustomerName: name, From: dateRangeValue?.From.format('YYYY-MM-DD'), To: dateRangeValue?.To.format('YYYY-MM-DD'), ShowOnlyMyErasures: dateRangeValue?.ShowOnlyMyErasures });
        setLoading(false);
        setOverview(data);
    };

    const filterDataMyErasure = async (checked) => {
        if (fromKPI) {
            return;
        }
        setLoading(true);
        let data = await fetchStatistic({ ActiveCustomerID: activeCustomer, CustomerName: name, From: dateRangeValue?.From.format('YYYY-MM-DD'), To: dateRangeValue?.To.format('YYYY-MM-DD'),  ShowOnlyMyErasures: checked });
        setLoading(false);
        setOverview(data);
    };

    useEffect( () => {
        const refetch = async () => {
            if (refetchTab) {
                await filterCustomer(name);
                setRefetchTab(false);
            }
        }
        refetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refetchTab]);

    return (
        <Card
            {...rest}
            className={clsx(classes.root, className)}
        >
            <CardContent>
                <Grid
                    container
                    justify="space-between"
                >
                    {hasPermission(permissions, 'access_all_customers') ?
                        <div className={classes.content}>
                            <Grid>
                                {dateRangeValue && <DataRange
                                    formSettings={formSettings}
                                    initialValues={dateRangeValue}
                                    filterDataRange={filterDataRange}
                                    loading={loading}
                                    value={dateRangeValue}
                                    filterDataMyErasure={filterDataMyErasure}
                                    setValue={setDateRangeValue}
                                    format="yyyy/MM/dd 00:00:00"
                                    translations={translations}
                                    hideOptions={hideOptions}
                                />}

                                {!hideOptions && <TextField id="standard-basic" className={classes.textField}
                                    label={translations['overview_field_label'] || "Customer filter "}
                                    onChange={handleChange}
                                    helperText={translations['overview_helper_text'] || "If field is empty it will present data (from last 48h) for all customers"} />}

                                {!fromKPI && <Tooltip className={classes.refresh} title={translations['refresh'] || "Refresh"}>
                                    <IconButton aria-label={translations['refresh'] || "Refresh"} component="div"
                                                disabled={loading}
                                                onClick={() => filterCustomer(name)}>
                                        <Refresh/>
                                    </IconButton>
                                </Tooltip>}
                            </Grid>
                        </div> : <div className={classes.root2}>
                            {dateRangeValue && <DataRange
                                formSettings={formSettings}
                                initialValues={dateRangeValue}
                                filterDataRange={filterDataRange}
                                loading={loading}
                                format="yyyy/MM/dd 23:59:59"
                                value={dateRangeValue}
                                filterDataMyErasure={filterDataMyErasure}
                                setValue={setDateRangeValue}
                                translations={translations}
                            />}
                            <Tooltip className={classes.refresh} title={translations['data_from_last'] || "Data from last 48h"}>
                                <IconButton aria-label={translations['refresh'] || "Refresh"} component="div" disabled={loading} onClick={() => {
                                    return props.fetchStatistic({ ActiveCustomerID: activeCustomer, ...dateRangeValue, From: dateRangeValue?.From.format('YYYY-MM-DD'), To: dateRangeValue?.To.format('YYYY-MM-DD'), });
                                }}>
                                <Refresh />
                            </IconButton>
                        </Tooltip>
                        </div>
                    }
                </Grid>
            </CardContent>
        </Card>
    );
};


export default withStyles(styles, { withTheme: true })(HeaderCard);
